import { css } from 'styled-components';
import token from 'styled-token';
import { StyledHighlight } from '../../components/Highlight/Highlight.styles';
export var ComboboxOptionMixin = function ComboboxOptionMixin(props) {
  return token({
    fontWeight: 'ComboboxOption.Highlight.fontWeight',
    backgroundColor: 'ComboboxOption.Highlight.backgroundColor'
  }, function (_ref) {
    var _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? 'bold' : _ref$fontWeight,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
    return css(["", "{font-weight:", ";background-color:", ";}"], StyledHighlight, fontWeight, backgroundColor);
  })(props);
};